<template>
  <div class="receivedGridExample" ref="list">
    <div class="top">
      <SearchBar @searchHandle="searchHandle"></SearchBar>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
      style="padding: 0 15px"
      v-if="!emptyShow"
    >
      <DetailListItem v-for="(item, index) in list" :key="index" :item="item"></DetailListItem>
    </van-list>
    <div class="empty-container" v-else>
      <Error type="empty"/>
    </div>
  </div>
</template>

<script>
import {queryReceivedEximplItemList} from '@/api/MineMore'
export default {
  name: "receivedGridExample",
  components: {
    SearchBar: () => import('@/components/MineMore/SearchBar'),
    DetailListItem: () => import('@/components/MineMore/DetailListItem'),
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      error: false,
      pageIndex: 0,
      emptyShow: false, //空空如也是否显示
      keyword: '',
    }
  },
  methods: {
    onLoad() {
      var params = {
        category_code: this.$route.query.category_code?this.$route.query.category_code:'',
        type_code: this.$route.query.id?this.$route.query.id:'',
        source_code: this.$route.query.source_code?this.$route.query.source_code:'',
        state: this.$route.query.status?this.$route.query.status:'',
        pageIndex: this.pageIndex?this.pageIndex:0,
        pageSize:this.pageSize?this.pageSize:10000,
        item_name: this.keyword?this.keyword:'',
      }
      this.loading = true;
      queryReceivedEximplItemList(params)
        .then(resp => {
          this.isBatchHandle = resp.isBatchHandle? resp.isBatchHandle : 'false';
          if(resp.data){
            this.allCheck = false;
            this.list = this.list.concat(resp.data)
            
            if (this.list.length >= resp.total) this.finished = true
            if (!resp.total){
              this.emptyShow = true;
            } else {
              this.emptyShow = false;
            }
            this.pageIndex++
            this.loading = false
          }else{
            this.loading = false
            if (this.list && this.list.length == 0) {
              this.emptyShow = true;
            }
          }
        })
        .catch(error => {
          this.loading = false
          this.error = true
          // this.$router.push('/empty/error')
        })
        .finally(() => {
          this.loading = false
        })
    },
    searchHandle(keyword) {
      this.keyword = keyword;
      this.$refs.list.scrollTop = 0
      this.list = []
      this.pageIndex = 0
      this.loading = true
      this.finished = false
      this.onLoad()
      this.mixinShowLoading()
    }
  }
}
</script>

<style lang="scss" scoped>
.receivedGridExample{
  height: 100vh;
  padding: 60px 0 15px;
  box-sizing: border-box;
  overflow-y: auto;
}
.top{
  height: 45px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
</style>
